import { render, staticRenderFns } from "./DeclarationsView.vue?vue&type=template&id=9d7a36b6&scoped=true"
import script from "./DeclarationsView.vue?vue&type=script&lang=js"
export * from "./DeclarationsView.vue?vue&type=script&lang=js"
import style0 from "./DeclarationsView.vue?vue&type=style&index=0&id=9d7a36b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a36b6",
  null
  
)

export default component.exports